import { Group, Text } from '@mantine/core'

import { sinalDoRssi } from './redes'

/**
 * Quatro barras crescentes, traço em grade de 16 px. Acesa na cor da marca,
 * apagada na borda — sem cor nova (DESIGN_SYSTEM.md 2.2 e 2.4). O rótulo em
 * texto vai junto: a barra sozinha não é lida por leitor de tela.
 */
export function SinalWifi({ rssi }: { rssi: number }) {
  const s = sinalDoRssi(rssi)
  return (
    <Group gap={6} wrap="nowrap">
      <svg width={16} height={16} viewBox="0 0 16 16" aria-hidden="true" data-barras={s.barras}>
        {[0, 1, 2, 3].map((i) => (
          <rect
            key={i}
            x={1 + i * 4}
            y={12 - i * 3}
            width={2.5}
            height={3 + i * 3}
            rx={0.5}
            fill={i < s.barras ? 'var(--mantine-color-inovareTeal-7)' : 'var(--ai-border-medium)'}
          />
        ))}
      </svg>
      <Text size="xs" c="dimmed">{`Sinal ${s.rotulo}`}</Text>
    </Group>
  )
}
